import { InputField } from "kubra-ux-forge";
import React, { ChangeEvent } from "react";
import { useField } from "formik";
import { getWcagAutocompleteValue } from "utilities/wcag";

interface PhoneNumberProps {
  name: string;
  label: string;
  placeholder?: string;
  editableIfPrefilled?: boolean;
}

export const PhoneNumber: React.FC<PhoneNumberProps> = ({
  name,
  label,
  placeholder,
  editableIfPrefilled,
}) => {
  const [field, meta, helpers] = useField(name);

  let disabled = false;

  if (meta.initialValue && !editableIfPrefilled) {
    disabled = true;
  }

  function formatPhoneNumber(inputPhone: string) {
    return inputPhone
      .replace(/\D+/g, "")
      .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
  }

  // TODO: use something like libphonenumber-js to validate and format phone numbers.
  const handlePhoneNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
    const regex = /^[0-9\b()-]+$/;

    if (
      event.currentTarget.value === "" ||
      regex.test(event.currentTarget.value.replace(/[^\d]/g, ""))
    ) {
      if (event.currentTarget.value.length < 15) {
        // Replace all non-digits with an empty string.
        const rawValue = event.currentTarget.value.replace(/\D/g, "");
        // Re-format the phone number to be in the format XXX-XXX-XXXX because Invoice API
        // expects the phone number to be in this format.
        const formattedValue = rawValue.replace(
          /(\d{3})(\d{3})(\d{4})/,
          "$1-$2-$3",
        );
        helpers.setValue(formattedValue);
      }
    }
  };

  return (
    // TODO: use appropriate class.
    <div className="bank-account-name-textbox-container">
      <InputField
        {...field}
        onChange={handlePhoneNumberChange}
        errorText={meta.touched ? meta.error : undefined}
        hasError={meta.touched ? !!meta.error : false}
        aria-invalid={meta.touched && !!meta.error}
        label={label}
        value={formatPhoneNumber(field.value ?? "")}
        dataCy={name}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete={getWcagAutocompleteValue(name, label)}
      />
    </div>
  );
};
